import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import BaseDetailScreen from '../BaseDetailScreen';
import './styles.css';


const Component = (props) => {
  if (!('firstName' in props.identity)) {
    return <Redirect to="/login" push={false} />;
  }
  return (
    <BaseDetailScreen pageHeading="Arbitration Clauses" backLabel={props.backLabel || 'Return to Sign Up'} backTo={props.backTo || '/sign-up/signature'} >
      <div styleName="certificationMain">
        <p styleName="certificationLink">
          <a href="https://www.folioinstitutional.com/servlets/ProcessAction/document/folioDoc?partnerCode=IAFIRM&docTypeCode=ACA#page=8" target="blank">
            Folio Investments, Inc. Arbitration Clause
          </a>
        </p>
        <p styleName="certificationLink">
          <a href="/static/docs/My_IPO_Customer_Agreement_Folio_CLICK_THROUGH_VERSION_final_7-18-18.pdf" target="_blank">
            Cambria Capital, LLC dba My IPO Arbitration Clause
          </a>
        </p>
        <p styleName="arbitrationThanks">
          Thank you for reviewing the pre-dispute arbitration clauses
          located at Part 2 of the Arbitration paragraph of the Folio
          Customer Agreement on page 8 and on page 1 of the Cambria
          Capital, LLC dba My IPO Customer Agreement.
        </p>
      </div>
    </BaseDetailScreen>);
};

Component.displayName = 'ArbitrationClauses';

const mapStateToProps = state => ({
  identity: state.rrSignupForms.personalInfo.identity,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/SignUp/ArbitrationClauses.js